import { render } from "./ElementosControleForm_11.vue?vue&type=template&id=c80c949a&scoped=true"
import script from "./ElementosControleForm_11.vue?vue&type=script&lang=js"
export * from "./ElementosControleForm_11.vue?vue&type=script&lang=js"

import "./ElementosControleForm_11.vue?vue&type=style&index=0&id=c80c949a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80c949a"]])

export default __exports__